export const hidenMessageAPI = [
  "user-preferences-general",
  "/auth/login/",
  "/auth/logout/",
  "/auth/token-refresh/",
  "/forgot-password-request/",
  "/forgot-password-reset/",
  "/jivandhara/payment-settings/",
  "/jivandhara/products/",
  "/jivandhara/product-categories/",
  "/jivandhara/donations/my-history/",
  "/jivandhara/product-orders/",
];
